export default __webpack_public_path__ + "static/media/institute-14-min.0a447c59.webp";